export type PopupDataProps<T> = T extends { data: unknown } ? T['data'] : null;

export type PopupOnActionProps<T> = T extends { onAction: unknown }
  ? T['onAction']
  : never;
export interface BasePopupActionPayload<T> {
  type: T;
}

export interface BasePopupProps<D = unknown, A = unknown> {
  data: D;
  onAction: A;
}

export interface PopupEventPayload {
  popup: string;
  action: any;
}

export type PopupType = React.ComponentType<BasePopupProps<any, any>>;

export type PopupItem = {
  name: string;
  component: PopupType;
};

type PopupProps<P extends PopupType> = React.ComponentProps<P>;

export type PopupData<T extends PopupType> = PopupDataProps<PopupProps<T>>;

export type PopupAction<T extends PopupType> = PopupOnActionProps<
  PopupProps<T>
>;

export interface PopupQuenue {
  name: string;
  data: PopupDataProps<PopupProps<PopupType>>;
}

export enum PopupNames {
  AdsFloatingBubble = 'AdsFloatingBubble',
  AdsVideo = 'AdsVideo',
  AgeVerification = 'AgeVerification',
  BuySticker = 'BuySticker',
  InitSticker = 'InitSticker',
  Interstitial = 'Interstitial',
  LimitTimeOffer = 'LimitTimeOffer',
  MyVisits = 'MyVisits',
  MyLikes = 'MyLikes',
  PerfectMatch = 'PerfectMatch',
  PromoteVip = 'PromoteVip',
  UploadPhoto = 'UploadPhoto',
  UserProfileUnlock = 'UserProfileUnlock',
  UserTransfer = 'UserTransfer',
  StopExist = 'StopExist',
  UserBan = 'UserBan',
}
